import React from 'react';
import {Container} from '@tempo/core';

type ContentLayoutProps = {
	children: React.ReactNode;
};

// TODO investigate layout for policies
const ContentLayout = ({children}: ContentLayoutProps) => {
	return (
		<Container maxW={'container.2xl'} px={{base: 4, sm: '40px', lg: '132px'}}>
			{children}
		</Container>
	);
};

export default ContentLayout;
